<template>
  <sidebar-menu :menu="menu" />
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    theme: {
      type: String,
      default: 'white-theme'
    },
        relative: {
      type: Boolean,
      default: true
    },
        widthCollapsed: {
      type: String,
      default: '20px'
    },
  },
  data() {
    return {
      menu: [
        {
          header: true,
          title: 'Dashboard Mitra',
          hiddenOnCollapse: true
        },
        {
          href: '/',
          title: 'Dashboard',
          icon: 'fa fa-user'
        },
        {
          href: '/',
          title: 'Manajemen Produk',
          icon: 'fa fa-user'
        },
        {
          href: '/',
          title: 'Profil Mitra',
          icon: 'fa fa-user'
        },
        {
          href: '/',
          title: 'Pengajuan Masuk',
          icon: 'fa fa-user'
        },
        {
          href: '/',
          title: 'Manajemen Pengajuan',
          icon: 'fa fa-user'
        },
      ]
    }
  },
}
</script>

<style scoped>
  sidebar-menu {
    background: #f4f4f4
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/sidebar.vue